import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import Tooltip from "../common/Tooltip";
import * as types from "../../constants/ComponentConstants";
import ValidationMessage from "../common/ValidationMessage";

const CheckBoxGroup = (props) => {
	const hasValidationMessage = !!props.validationMessage;
	const validationMessageType = props.validationMessageType;
	const tooltiptype = props.tooltipType || types.TOOLTIP_INFO;
	const sizeClassName = props.size ? "o-col-" + props.size : "o-col-12";
	const label = (props.label ? props.label : "") + (props.optional ? " (Optioneel)" : "");
	let value = "null";
	if (props.value != null) {
		if (props.value == false || props.value == "false") {
			value = false;
		} else if (props.value == true || props.value == "true") {
			value = true;
		}
	}
	const disabled = props.disabled || props.readonly;
	const info = props.tooltip ? <Tooltip text={props.tooltip} tooltipType={tooltiptype} isInput /> : null;
	const validation = props.validationMessage ? <ValidationMessage validationMessage={props.validationMessage} type={validationMessageType} /> : null;

	const checkClassName = {
		"c-input": true,
		"radiobuttonlist": true,
		"disabled": disabled,
		"inline": props.horizontal,
		"error": hasValidationMessage,
		"warning": hasValidationMessage && validationMessageType === types.ValidationMessageTypes.WARNING
	};
	const options = props.items.map((item, i) =>
		<div key={props.name + i} className="c-input__group">
			<input type="checkbox" name={props.name} onChange={props.onChange} value={item.value}
				checked={item.value.toString() === value.toString()} id={props.name + i} disabled={disabled} />
			<label htmlFor={props.name + i}>{item.label}</label>
		</div>);

	return (
		<div value={props.value} className={classnames(sizeClassName)}>
			<div className={classnames(checkClassName)}>
				<div className="c-input__label has-value">{label}</div>
				<div className="c-input__field">{options}</div>
				{info}
			</div>
			{validation}
		</div>
	);
};

CheckBoxGroup.propTypes = {
	name: PropTypes.string.isRequired,
	label: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	items: PropTypes.array.isRequired,
	value: PropTypes.oneOfType([
		PropTypes.bool,
		PropTypes.string
	]),
	tooltip: PropTypes.string,
	tooltipType: PropTypes.string,
	horizontal: PropTypes.bool,
	size: PropTypes.number,
	validationMessage: PropTypes.string,
	validationMessageType: PropTypes.string,
	disabled: PropTypes.bool,
	readonly: PropTypes.bool,
	optional: PropTypes.bool
};

export default CheckBoxGroup;
